export function getMonths() {
    const current = getCurrentDateObject();
    const monthsWithYear = [current];

    // Obtain last 3 months
    for (let monthIndex = 1; monthIndex <= 3; monthIndex++) {
      let monthWithYear = {
        month: current.month - monthIndex,
        year: current.year
      };
    
      if(monthWithYear.month < 0) {
        monthWithYear.month = 12 + monthWithYear.month;
        monthWithYear.year = current.year - 1;
      }
      monthsWithYear.push(monthWithYear);
    }

    const result = monthsWithYear.map(monthWithYear => ({
        id: formatMonthYear(monthWithYear),
        name: convertMonthToString(monthWithYear.month, monthWithYear.year)
    }));

    return result;
}

export function getNextMonths() {
    const current = getCurrentDateObject();
    const monthsWithYear = [current];
  
    // Obtain last 3 months
    for (let monthIndex = 1; monthIndex <= 3; monthIndex++) {
      let monthWithYear = {
        month: current.month + monthIndex,
        year: current.year
      };
    
      if(monthWithYear.month > 12) {
        monthWithYear.month = 0 + monthWithYear.month;
        monthWithYear.year = current.year + 1;
      }
      monthsWithYear.push(monthWithYear);
    }
  
    const result = monthsWithYear.map(monthWithYear => ({
        id: formatMonthYear(monthWithYear),
        name: convertMonthToString(monthWithYear.month, monthWithYear.year)
    }));
  
  
    return result;
  }

  export function getDefaultSelectedMonths(upcoming=false) {
    //Add current and previous month
  function getCurrentAndPreviousMonth(current){
    let previous = {
      month: current.month - 1,
      year: current.year
    };
  
    if(previous.month < 0) {
      previous.month = 11;
      previous.year = current.year - 1;
    }
    return previous;

  }
   //Add current and next month
  function getCurrentAndNextMonth(current){
    let next = {
      month: current.month + 1,
      year: current.year
    };
  
    if(next.month > 12 ) {
      next.month = 0;
      next.year = current.year + 1;
    }
    return next;

  }
 
  const current = getCurrentDateObject();
  const monthsWithYear = [current];
  let pubDate = null;
  if(upcoming){
    pubDate = getCurrentAndNextMonth(current);
  }else{
    pubDate = getCurrentAndPreviousMonth(current);
  }

  monthsWithYear.push(pubDate);
  const result = [];
  for(const monthWithYear of monthsWithYear) {
    result.push(formatMonthYear(monthWithYear));
  }

  return result;
}

const formatMonthYear = (monthWithYear) => (`${monthWithYear.year}-${monthWithYear.month}`);

function getCurrentDateObject() {
  const currentDate = new Date();

  const current = {
    month: currentDate.getMonth(),
    year: currentDate.getFullYear()
  };

  return current;
}

// each position in the array corresponds to a month: [jan, feb, mar, apr, may,...]
const lastDayOfMonth = [31,28,31,30,31,30,31,31,30,31,30,31];


function convertMonthToString(monthNumber, yearNumber){
  const date = new Date();
  //The following line prevents an issue when today is 31st and you want to set the month to one whose last day is 30.
  date.setDate(lastDayOfMonth[monthNumber]);
  date.setMonth(monthNumber);
  date.setFullYear(yearNumber);

  const month = date.toLocaleString('en-us', { month: 'short', year: 'numeric'});
  return month;
}